import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import RedirectButton from 'components/Common/Buttons/RedirectButton';
import ErrorGraphic from '../ErrorGraphic';

const UnauthorizedPage = ({ caption }) => (
  <div>
    <ErrorGraphic />
    <div className="message-404-box">
      <h1>Access Denied</h1>
      <p>{ caption }</p>
      <div className="buttons-con">
        <div className="action-link-wrap">
          <RedirectButton
            to="/"
            title="Go back"
            className="btn link-go-back"
            redirectBack
          />
          <Link to="/" className="link-button">Go to home page</Link>
        </div>
      </div>
    </div>
  </div>
);

UnauthorizedPage.propTypes = {
  caption: PropTypes.string
};

UnauthorizedPage.defaultProps = {
  caption: 'You must be logged with the correct rights to access this page. Please check your login and try again or speak to your system administrator.'
};

export default UnauthorizedPage;
